import { prop, path } from 'ramda';
import { createSelector } from 'reselect';

const KEY = 'diagnosis';

export const getDiagnosis = prop(KEY);

export const getEvent = path([KEY, 'event']);
export const getEventDetails = path([KEY, 'eventDetails']);
export const getFlatTire = createSelector(getEventDetails, prop('flatTire'));
export const getWindScreenDetails = createSelector(getEventDetails, prop('windscreenDetails'));

export const getEventCode = createSelector(getEvent, prop('code'));
export const getSpareTire = createSelector(getEventDetails, prop('spareTire'));
export const getNumberOfPassengers = createSelector(getEventDetails, prop('nbPersons'));
export const getPersonSpecialNeeds = createSelector(getEventDetails, prop('personWithSpecialNeeds'));
export const getPersonInjured = createSelector(getEventDetails, prop('injuredPaxSubscriberCar'));
export const getOtherCarInvolved = createSelector(getEventDetails, prop('otherCarInvolved'));
export const getPersonInjuredCarInvolved = createSelector(getEventDetails, prop('injuredPax3rdPartyCar'));
export const getCarFuelType = createSelector(getEventDetails, prop('carFuelType'));
export const getCarDrivable = createSelector(getEventDetails, prop('carDrivable'));
export const getCarFoundAfterTheft = createSelector(getEventDetails, prop('carFoundAfterTheft'));
export const getCarOffRoad = createSelector(getEventDetails, prop('carOffRoad'));
export const getCarUpsideDown = createSelector(getEventDetails, prop('carUpsideDown'));
export const getFilledFuelType = createSelector(getEventDetails, prop('filledFuelType'));
export const getVandalismDamages = createSelector(getEventDetails, prop('vandalismDamages'));

export const getFrontLeftTire = createSelector(getFlatTire, prop('frontLeft'));
export const getFrontRightTire = createSelector(getFlatTire, prop('frontRight'));
export const getRearLeftTire = createSelector(getFlatTire, prop('rearLeft'));
export const getRearRightTire = createSelector(getFlatTire, prop('rearRight'));

export const getWindScreenBroken = createSelector(getWindScreenDetails, prop('windscreenBroken'));
export const getRearWindScreenBroken = createSelector(getWindScreenDetails, prop('rearWindscreenBroken'));
export const getOtherWindowBroken = createSelector(getWindScreenDetails, prop('otherWindowBroken'));
